import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import IntegrationsLayout from './IntegrationsLayout';
import IntegrationsPage from './IntegrationsPage';
import FacebookIntegration from './FacebookIntegration';
import CustomWebhooks from '../settings/CustomWebhooks';
import CustomWebhookDetail from '../settings/CustomWebhookDetail';
import WhatsAppSettings from '../settings/WhatsAppSettings';
import McpCredentials from './McpCredentials';

const IntegrationsBase = () => (
  <Routes>
    <Route element={<IntegrationsLayout />}>
      <Route index element={<Navigate to="/integrations/facebook" replace />} />
      <Route path="overview" element={<Navigate to="/integrations/facebook" replace />} />
      <Route path="facebook" element={<FacebookIntegration />} />
      <Route path="facebook/:pageId" element={<FacebookIntegration />} />
      <Route path="automation" element={<Navigate to="/social-media-automation" replace />} />
      <Route path="whatsapp" element={<IntegrationsPage section="whatsapp" />} />
      <Route path="magicbricks" element={<IntegrationsPage section="magicbricks" />} />
      <Route path="99acres" element={<IntegrationsPage section="99acres" />} />
      <Route path="housing" element={<IntegrationsPage section="housing" />} />
      <Route path="google-ads" element={<IntegrationsPage section="google_ads" />} />
      <Route path="mcp" element={<McpCredentials />} />
      <Route path="custom-webhooks" element={<CustomWebhooks />} />
      <Route path="custom-webhooks/:webhookId" element={<CustomWebhookDetail />} />
      <Route path="whatsapp-settings" element={<WhatsAppSettings />} />
    </Route>
  </Routes>
);

export default IntegrationsBase;
